import React from 'react'

import { Body1 } from '@ui/Typography/Typography'

import { Box } from '@shared/components/Box'

import styles from './style.module.scss'

interface Props {
  groups?: { label: string; value: string | number }[][]
}

export const ModalBodyListGroup: React.FC<Props> = ({ groups }) => (
  <Box fullWidth flex direction='column' gap='x12'>
    {groups?.map((group, i) => [
      <Box flex direction='column' gap='x4' key={i} align='flex-start'>
        {group.map(({ label, value }) => (
          <Body1 color='text-med-em'>
            {label}: {value}
          </Body1>
        ))}
      </Box>,
      i < groups.length - 1 && <hr className={styles.divider} />,
    ])}
  </Box>
)
